import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
    allproducts: [],
    products: [],
    pagination: [],
    cart: []
  },

  actions: {
    // 操作的方法
    updateLoading(context, status) {
      context.commit("LOADING", status);
    },
    getAllProducts(context, status) {
      const url = `${process.env.APIPATH}/api/${process.env.CUSTOMPATH}/products/all`;
      context.commit("LOADING", true);

      axios.get(url).then(response => {
        context.commit("LOADING", false);
        context.commit("ALLPRODUCTS", response.data.products);
      });
    },
    getProducts(context, status = 1) {
      const url = `${process.env.APIPATH}/api/${process.env.CUSTOMPATH}/products?page=${status}`;
      axios.get(url).then(response => {
        if (response.data.success) {
          context.commit("PRODUCTS", response.data.products);
          context.commit("PAGE", response.data.pagination);
        }
      });
    },
    getCarts(context, status) {}
  },

  mutations: {
    //改變資料的狀態
    // 盡量用大寫命名
    LOADING(state, status) {
      // 在這裡修改資料狀態
      state.isLoading = status;
    },
    ALLPRODUCTS(state, payload) {
      state.allproducts = payload;
    },
    PRODUCTS(state, payload) {
      state.products = payload;
    },
    PAGE(state, payload) {
      state.pagination = payload;
    }
  },
  getters: {
    randomProducts(state) {
      let randomList = [];
      let newArray = [...state.products];
      if (newArray.length >= 7) {
        for (let index = 0; index < 7; index++) {
          let n = Math.floor(Math.random() * newArray.length);
          randomList.push(newArray[n]);
          newArray.splice(n, 1);
        }
        return randomList;
      } else {
        return state.products;
      }
    }
  },
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js